import type { FC } from 'react';

type DnaPillProps = {
  label: string;
  selected: boolean;
  badgeCount?: number;
  disabled?: boolean;
  onClick: () => void;
};

const DnaPill: FC<DnaPillProps> = ({
  label,
  selected,
  badgeCount = 0,
  disabled = false,
  onClick,
}) => {
  const showBadge = badgeCount > 0;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      aria-label={
        showBadge
          ? `${label}, ${badgeCount} subcategories selected`
          : label
      }
      className={`inline-flex items-center justify-center gap-2 rounded-full border px-5 py-2.5 font-sans text-sm font-semibold transition-[transform,background-color,border-color,color,opacity] duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-[var(--gold)] ${
        selected
          ? 'border-[var(--gold)] bg-[var(--gold-lt)] text-[var(--ink)]'
          : 'border-[var(--gold-deep)] bg-transparent text-[var(--cream)]'
      } disabled:cursor-not-allowed disabled:opacity-50 hover:-translate-y-0.5`}
    >
      <span>{label}</span>

      {showBadge ? (
        <span
          className="flex h-6 min-w-6 items-center justify-center rounded-full bg-[var(--ink)] px-1.5 text-xs font-semibold leading-none text-[var(--gold-lt)] shadow-[0_0_0_1px_var(--gold-deep)]"
          aria-hidden="true"
        >
          {badgeCount}
        </span>
      ) : null}
    </button>
  );
};

export default DnaPill;